import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { getEndDate, getStartDate } from '../selectors';
import { selectStartDate, selectEndDate } from '../../actions';
import { resetDirty, setDirty } from '../../metrics/actions';
import Filters from '../components/Filters';
import {
  getBarberFilterForApi,
  isDirty,
  hasDateChanged,
  getAreAllBarbersSelected,
  getFiltersForMetrics,
} from '../../metrics/selectors';
import {
  getBrandFiltersForApi,
  getServiceCategoryFilterForApi,
} from '../../selectors';
import Criteria from '../../metrics/Criteria';
import { getDefaultReportRange } from '../../../../common/helpers/times';

export default compose(
  connect(
    state => ({
      startDate: getStartDate(state),
      endDate: getEndDate(state),
      isFetching: Boolean(state.loadingBar),
      isSubmitDisabled: !isDirty(state) || Boolean(state.loadingBar),
      serviceCategories: getServiceCategoryFilterForApi(state),
      barberFilter: getBarberFilterForApi(state),
      hasDateChanged: hasDateChanged(state),
      productBrands: getBrandFiltersForApi(state),
      allBarbersSelected: getAreAllBarbersSelected(state),
      filters: getFiltersForMetrics(state),
      useUserLocalTime: true,
    }),
    {
      selectStartDate,
      selectEndDate,
      resetDirty,
      setDirty,
    },
  ),
  withHandlers({
    onDateChange: props => (start, end) => {
      props.selectStartDate(start);
      props.selectEndDate(end);
    },
    applyFilter: props => () => props.fetcher(
      new Criteria({
        fromDate: props.filters.fromDate,
        toDate: props.filters.toDate,
        barberFilter: props.filters.barberFilter,
        serviceCategoryFilter: props.filters.serviceCategories,
        productBrandFilter: props.filters.productBrands,
        barberId: props.filters.barberId,
        shopId: props.filters.shopId,
        brandId: props.filters.brandId,
        shopFilter: props.filters.shopFilter,
      })
    ),
  }),
  lifecycle({
    componentDidMount() {
      const isInitialized = this.props.startDate !== null || this.props.endDate !== null;
      if (!isInitialized) {
        const dateRange = getDefaultReportRange();
        const startDate = dateRange.from;
        const endDate = dateRange.to;
        this.props.onDateChange(startDate, endDate);
      }

      return this.props.fetchAfterMount
        ? this.props.applyFilter()
        : this.props.setDirty();
    },
    componentWillUnmount() {
      this.props.resetDirty();
    },
  }),
)(Filters);
